var $ = require('jquery')
require('slick-carousel')

$(function () {
  $('.js-example-main-slick-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.js-example-thumbnail-slick-slider',
    adaptiveHeight: true,
    lazyLoad: 'progressive'
  })

  $('.js-example-thumbnail-slick-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    asNavFor: '.js-example-main-slick-slider',
    centerMode: false,
    focusOnSelect: true,
    lazyLoad: 'ondemand'
  })

  const options = {
    speed: 800,
    dots: false,
    infinite: false,
    arrows: true,
    centerMode: true,
    centerPadding: '23%',
    lazyLoad: 'progressive',
    responsive: [{
      breakpoint: 768,
      settings: {
        centerPadding: '0',
        arrows: true
      }
    }]
  }

  // [FIXME] .js-review-slider は消して、.js-slick-slider に統一したい
  $('.js-review-slider').slick(options)
  $('.js-slick-slider').slick(options)
})
